export const nullCheckFormValues = obj =>
    JSON.parse(JSON.stringify(obj, (k, v) => (v === null ? '' : v)));

const omitTypename = (key, value) => (key === '__typename' ? undefined : value);
export const cleanPayload = payload => JSON.parse(JSON.stringify(payload), omitTypename);
